import axios from "./axios";

const getWebParts = async () => {
  const response = await axios.get(`/api/V1/Ui/WebPart/GetWebPartsForUi`, {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    },
  });
  return response.data.data;
};

const getHomeProducts = async () => {
  const response = await axios.get(
    `/api/V1/Ui/Product/GetProductsForUi?count=6`,
    {
      headers: {
        SubSystemKey: window.Configs["sub-system-key"],
      },
    }
  );
  return response.data.data;
};

const getAllProducts = async () => {
  const response = await axios.get("/api/V1/Ui/Product/GetProductListForUi", {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    },
  });
  return response?.data?.data?.items;
};

const getAllReciepe = async () => {
  const response = await axios.get("/api/V1/Ui/Recipe/GetRecipeListForUi", {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    },
  });
  return response.data;
};

//news
const getAllNews = async () => {
  const response = await axios.get("/api/V1/Ui/Article/GetArticleListForUi", {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    }
  });
  return response.data.data;
};
const getHomeNews = async () => {
  const response = await axios.get("/api/V1/Ui/Article/GetArticlesForUi?count=4", {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    },
  });
  return response.data.data;
};

const getAwards = async () => {
  const response = await axios.get(`/api/V1/Ui/Slide/GetSlidesForUi`, {
    headers: {
      SubSystemKey: window.Configs["sub-system-key"],
    },
  });
  return response.data.data;
};


export { getWebParts, getHomeProducts, getAllProducts, getAllReciepe, getAllNews, getHomeNews, getAwards };
